import { useAuth } from '@/context/AuthContext'
import { usePartner } from '@/context/PartnerContext'
import { Logout } from '@/icons'
import { Box, Button, Container, Flex, Grid, HStack, Image } from '@chakra-ui/react'

export const PoleasHeader = () => {
  const { logout } = useAuth()
  const { currentPartner } = usePartner()

  return <Box as="header" id="header" sx={{ bgColor: 'white' }}>
    <Container py={4}>
      <Grid
        sx={{
          w: '100%',
          alignItems: 'center',
          justifyContent: 'space-between',
          gridTemplateColumns: '1fr 1fr'
        }}
      >
        <Flex sx={{ w: '100%', justifyContent: 'space-between', alignItems: 'center' }}>
          <Image src={currentPartner?.logo} alt="Logo" h={14} my={-6} />
        </Flex>

        <Flex sx={{ w: '100%', justifyContent: 'flex-end', alignItems: 'center' }}>
          <Button onClick={() => logout()} variant="ghost" color="primary.800">
            <HStack>
              <Logout />
              <span>Odhlásit se</span>
            </HStack>
          </Button>
        </Flex>
      </Grid>
    </Container>
  </Box>
    
}